/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import React from 'react'
import Timeout from 'DesignSystem/Timeout/react'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Medical/Content/SyncAction/Content",
  onSubmit
  
}) {
let syncSubmitData = fromData.useDataSubmit({ viewPath,
context: 'sync',
})
  return (<React.Fragment
>
<Timeout
  viewPath={`${viewPath}/Timeout`}
 data="sync"
 onTimeout={syncSubmitData}
 delay={1000}
/>
{children}
</React.Fragment>)
}